import {
  updateTaxExemption,
  getIdentifierTemplate,
  getClientIdentifiers,
  addClientIdentifiers,
  getIdentifierDocument,
  getClientBillProfile,
  deleteClientIdentifiers,
  getAllClientDocuments,
  deleteClientDocument,
  uploadClientDocument,
  uploadIdentifierDocument,
  getClientCardDetails,
  addClientCardDetail,
  getAdditionalInfo,
  additionalInfoTemplate,
  createAdditionalInfoTemplate,
  getChildsByClientId,
  getdownloadDocumentProfile,
  getPaymentInfo,
  addChildToFamilyPlan,
  removeChildFromFamilyPlan,
  getChildListByParent,
  getParentDetailsByChild
} from "@/http/customer/customer";

export default {
  namespaced: true,
  state: {
    identifierTemplate: {},
    identifiers: [],
    clientBillProfile: {},
    clientDocuments: [],
    creditCardDetails: [],
    infoDataTemplates: {},
    additional: {},
    paymentInfoData: [],
    childs: [],
    parentDetails: [],
    childDetails: [],
    addChildResponse: {},
  },
  actions: {
    async addChildToFamilyPlanAction({ commit }, payload) {
      const response = await addChildToFamilyPlan(payload);
      commit("ADD_CHILD_RESPONSE", response.data);
      return response;
    },
    async removeChildFromFamilyPlanAction(_, payload) {
      const response = await removeChildFromFamilyPlan(payload);
      return response;
    },
    async getChildListByParentAction({ commit }, payload) {
      const response = await getChildListByParent(payload);
      commit("SET_CHILDS_BY_PARENT", response.data);
      return response;
    },
    async getParentDetailsByChildAction({ commit }, payload) {
      const response = await getParentDetailsByChild(payload);
      commit("SET_PARENT_DETAILS_BY_CHILD", response.data);
      return response;
    },
    async updateTaxExemptionAction(_, payload) {
      const response = await updateTaxExemption(payload);
      return response;
    },
    async getIdentifierTemplateAction({ commit }, payload) {
      const response = await getIdentifierTemplate(payload);
      commit("SET_IDENTIFIER_TEMPLATE", response.data);
      return response;
    },
    async getClientIdentifiersAction({ commit }, payload) {
      const response = await getClientIdentifiers(payload);
      commit("SET_CLIENT_IDENTIFIER", response.data);
      return response;
    },
    async addClientIdentifiersAction(_, payload) {
      return await addClientIdentifiers(payload.id, payload.data);
    },
    async getIdentifierDocumentAction({ commit }, payload) {
      const response = await getIdentifierDocument(payload);
      commit("SET_IDENTIFIER_DOCUMENT", response.data);
      return response;
    },
    async getClientBillProfileAction({ commit }, payload) {
      const response = await getClientBillProfile(payload);
      commit("SET_BILL_PROFILE_DATA", response.data);
      return response;
    },
    async deleteClientIdentifiersAction(_, payload) {
      return await deleteClientIdentifiers(payload.clientId, payload.id);
    },
    async getAllClientDocumentsAction({ commit }, payload) {
      const response = await getAllClientDocuments(payload);
      commit("SET_CLIENT_DOCUMENT", response.data);
      return response;
    },
    async deleteClientDocumentAction(_, payload) {
      return await deleteClientDocument(payload.clientId, payload.id);
    },
    async uploadClientDocumentAction(_, payload) {
      return await uploadClientDocument(payload.id, payload.data);
    },
    async uploadIdentifierDocumentAction(_, payload) {
      return await uploadIdentifierDocument(payload.id, payload.data);
    },
    async getClientCardDetailsAction({ commit }, payload) {
      const response = await getClientCardDetails(payload);
      commit("SET_CREDIT_CARD_DETAILS", response.data);
      return response;
    },
    async addClientCardDetailAction(_, payload) {
      return await addClientCardDetail(payload.id, payload.data);
    },
    async getAdditionalInfoAction({ commit }, payload) {
      const response = await getAdditionalInfo(payload);
      commit("SET_CLIENT_ADDITIONAL_INFO", response.data);
      return response;
    },
    async additionalInfoTemplateAction({ commit }, payload) {
      const response = await additionalInfoTemplate(payload);
      commit("SET_ADDITIONAL_INFO_TEMPLATE", response.data);
      return response;
    },
    async createAdditionalInfoTemplateAction(_, payload) {
      return await createAdditionalInfoTemplate(payload.id, payload.data);
    },
    async getChildsByClientIdAction({ commit }, payload) {
      const response = await getChildsByClientId(payload);
      commit("SET_CHILDS_BY_CLIENT_ID", response.data);
      return response;
    },
    async downloadHistory({ commit }, { clientId, id }) {
      const response = await getdownloadDocumentProfile(clientId, id);
      // commit("SET_CHILDS_BY_CLIENT_ID", response.data);
      return response;
    },
    async getPaymentsAction({ commit }, payload) {
      const resp = await getPaymentInfo(payload);
      commit("PAYMENT_INFO", resp.data);
      return resp;
    },
  },
  mutations: {
    SET_IDENTIFIER_TEMPLATE(state, payload) {
      state.identifierTemplate = payload;
    },
    SET_CLIENT_IDENTIFIER(state, payload) {
      state.identifiers = payload;
    },
    SET_IDENTIFIER_DOCUMENT(state, payload) {
      state.clientDocuments = payload;
    },
    SET_BILL_PROFILE_DATA(state, payload) {
      state.clientBillProfile = payload;
    },
    SET_CLIENT_DOCUMENT(state, payload) {
      state.clientDocuments = payload;
    },
    SET_CREDIT_CARD_DETAILS(state, payload) {
      state.creditCardDetails = payload;
    },
    SET_CLIENT_ADDITIONAL_INFO(state, payload) {
      state.infoDataTemplates = payload;
    },
    SET_ADDITIONAL_INFO_TEMPLATE(state, payload) {
      state.additional = payload;
    },
    SET_CHILDS_BY_CLIENT_ID(state, payload) {
      state.childs = payload;
    },
    SET_PARENT_DETAILS_BY_CHILD(state, payload) {
      state.parentDetails = payload;
    },
    SET_CHILDS_BY_PARENT(state, payload) {
      state.childDetails = payload;
    },
    ADD_CHILD_RESPONSE(state, payload) {
      state.addChildResponse = payload;
    },
    PAYMENT_INFO(state, payload) {
      state.paymentInfoData = payload;
    },
  },
  getters: {
    GetIdentifierTemplate(state) {
      return state.identifierTemplate;
    },
    GetClientIdentifiers(state) {
      return state.identifiers;
    },
    GetClientBillProfile(state) {
      return state.clientBillProfile;
    },
    GetClientDocuments(state) {
      return state.clientDocuments;
    },
    GetCreditCardDetails(state) {
      return state.creditCardDetails;
    },
    GetAdditionalInfo(state) {
      return state.infoDataTemplates;
    },
    AdditionalInfoTemplate(state) {
      return state.additional;
    },
    GetChildsByClientId(state) {
      return state.childs;
    },
  },
};
